var v = Object.defineProperty;
var L = (e, o, t) => o in e ? v(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t;
var u = (e, o, t) => L(e, typeof o != "symbol" ? o + "" : o, t);
const S = `/* General styles */
:host {
  display: block;
  font-family: 'VVCentra2', Helvetica, Arial, sans-serif;
  text-align: left;

  /* Rewrite inherited */
  text-transform: none;
}

:host * {
  box-sizing: border-box;
}

.AD_hidden {
  display: none !important;
}

.AD_Main {
  position: relative;
  display: grid;
  place-items: center;
}

/* Open/Close trigger icon */
.AD_TriggerIcon {
  cursor: pointer;

  display: flex;
  align-items: center;

  padding: 0;

  background: transparent;
  border: 0;
}

.AD_TriggerIcon:focus-visible {
  outline: 2px solid #151515;
}

.AD_TriggerIcon_Account {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  fill: var(--ad-color-1, #6e6e6e);
}

.AD_TriggerIcon_Arrow {
  width: 24px;
  height: 24px;

  vertical-align: middle;

  fill: var(--ad-color-1, #6e6e6e);

  transition: transform 200ms;
}

.isOpen .AD_TriggerIcon_Arrow {
  transform: rotate(180deg);
}

.AD_TriggerIcon_MobileLabel {
  display: none;

  margin-left: 8px;

  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  color: var(--ad-color-1, #151515);
  letter-spacing: 3px;
}

/* Content block, initially hidden */
.AD_Content {
  position: absolute;
  z-index: 99999;
  top: 24px;
  right: unset;
  left: 0;

  overflow: hidden auto;
  display: none;
  flex-direction: column;
  gap: 15px;
  align-items: center;

  width: 320px;
  margin-top: 24px;
  padding: 15px;

  background-color: white;
  border-radius: 3px;
  box-shadow: 0 0 4px 0 rgb(190 42 42 / 20%);
}

.isOpen .AD_Content {
  overflow: auto;
  display: flex;

  height: auto;

  visibility: visible;
  opacity: 1;
}

.AD_Content.hasVoyages {
  width: 375px;
}

.AD_Content.leftSided {
  right: 0;
  left: unset;
}

.AD_Content.AD_Content_InAccountApp.leftSided {
  right: 0;
  left: unset;
}

.AD_Content.centered {
  right: unset;
  left: -136px;
}

.AD_Content.AD_Content_InAccountApp.centered {
  right: 0;
  left: unset;
}

/* Search results */
.AD_SearchResults {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;

  width: 100%;
}

.AD_SearchResults_Img {
  display: block;
  width: 137px;
  height: auto;
}

.AD_SearchResults_Title {
  margin: 0;

  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
  color: #151515;
}

.AD_Main.hasSearchResults .AD_SearchResults_Title {
  align-self: flex-start;
}

.AD_TriggerIcon_Account_Status {
  fill: white;
}

.AD_Main.hasSearchResults.AD_TriggerIcon.AD_TriggerIcon_Account.AD_TriggerIcon_Account_Status {
  fill: #c00;
}

.AD_SearchResults_List {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;

  width: 100%;
}

.AD_SearchResults_List_NoSearches {
  font-size: 15px;
  line-height: 1.5;
  color: #6c757d;
}

.AD_SearchResults_ListItem {
  cursor: pointer;

  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;
  padding: 15px;

  font-size: 13px;
  line-height: 1.5;
  color: #000;
  text-decoration: none;

  border: 1px solid #e9ecef;
  border-radius: 4px;
}

.AD_SearchResults_ListItem:hover {
  background-color: #eee;
}

.AD_SearchResults_ListItem_Title {
  overflow: hidden;
  display: box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  /* start showing ellipsis when 3rd line is reached */

  font-weight: 700;
  white-space: pre-wrap;
}

.AD_SearchResults_ListItem.AD_VoyagesList {
  display: flex;
  flex-direction: row;
  gap: 0.9375rem;
  justify-content: space-around;
}

.AD_SearchResults_ListItem_Img_Wrap {
  width: 108px;
  height: 80px;
}

.AD_SearchResults_ListItem_Img {
  width: 100%;
  height: 100%;
  margin-bottom: 0 !important;
}

.AD_SearchResults_ListItem_Details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.AD_DashboardButton {
  cursor: pointer;

  width: 100%;
  padding: 10px 30px;

  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 2.2;
  color: #c00;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1.77px;

  background: transparent;
  border: 1px solid #c00;
  border-radius: 4px;

  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.AD_DashboardButton:hover {
  color: #fff;
  background-color: #c00;
}

.AD_LogoutButton {
  cursor: pointer;

  padding: 0;

  font-size: 15px;
  line-height: 1.54;
  color: #6e6e6e;
  text-decoration: underline;

  background-color: transparent;
  border: 0;
  border-radius: 0;
}

.AD_MobileCloseIcon {
  cursor: pointer;

  position: fixed;
  top: 15px;
  right: 15px;

  display: none;

  width: 20px;
  height: 20px;
  padding: 0;

  background: transparent;
  border: 0;
}

.AD_ContentOverlay {
  position: fixed;
  z-index: 99998;
  top: 0;
  left: 0;

  display: none;

  width: 100vw;
  height: 100vh;

  background-color: rgb(255 255 255 / 95%);
}

.AD_Content.AD_Content_Mobile.hasVoyages {
  width: 100%;
}

@media (max-width: 767.98px) {
  .isOpen .AD_MobileCloseIcon {
    display: block;
  }

  .AD_Content {
    position: fixed;
    top: 0;

    width: 100vw;
    max-height: 100vh;
    margin-top: 0;
  }

  .AD_SearchResults {
    margin-top: 50px;
  }

  .isOpen .AD_ContentOverlay {
    display: block;
  }

  .isOpen .AD_TriggerIcon {
    display: none;
  }

  .AD_TriggerIcon.AD_ShowMobileLabel .AD_TriggerIcon_MobileLabel {
    display: inline;
    padding: 15px 0;
  }

  .AD_TriggerIcon.AD_ShowMobileLabel .AD_TriggerIcon_Arrow {
    display: none;
  }

  .AD_TriggerIcon_Account {
    fill: var(--ad-color-1, #151515);
  }

  .AD_Content.leftSided {
    top: 0;
    left: 0;
  }

  .AD_TriggerIcon_MobileLabel_Voyages_Edit:not(.AD_HideMobileLabel) {
    padding: 0;
    display: none;
  }


  .AD_TriggerIcon_Arrow_Voyages_Edit:not(.AD_HideMobileLabel) {
    display: block;
  }

  .AD_TriggerIcon_Account_Voyages_Edit {
    fill: #686d72;
  }

}`, C = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.54 419.32">
  <defs>
    <clipPath id="clip-path" transform="translate(-29.63 -10.95)">
      <path
        d="M381.81 141c1.54 4.21 7.55 20.66 8.32 22.22a3.38 3.38 0 0 1 .47 2.75s-8.41-19.68-10.19-23.83c-3.35.17-14.57 0-30.93-7.72a33.81 33.81 0 0 1-5.47 4.78s5.27 19 .49 33.19l22.9 12.47c-.82.56-2.36-.12-2.36-.12l-21.82-11.04c-4 .6-20.37 1.84-33.36-15.56a18.23 18.23 0 0 1-2.66-4.46c5-2.51 12.72-6.81 22.84-8.87s21.32-11.25 24.67-20 8.75-19.9 14.36-23.87c0-.04 20.83 9.22 12.74 40.06Z"
        class="cls-1" />
    </clipPath>
    <style>
      .cls-1 {
        fill: none
      }

      .cls-3 {
        fill: #29b574
      }

      .cls-4 {
        fill: #c00
      }

      .cls-6 {
        fill: #fff
      }

      .cls-7 {
        fill: #0e123c
      }

      .cls-8 {
        fill: #f7d0ad
      }

      .cls-9 {
        fill: #e0b999
      }

      .cls-10 {
        fill: #298d5a
      }
    </style>
  </defs>
  <path
    d="M104.95 69.91c3-.93 5.38-2.7 6.38-5.82 1.67-5.21-3.35-10.43-8.64-11.82s-10.9-.37-16.34-1-10.66-2.8-16-4-11.5-1.14-15.86 2.23c-2.53 2-4.46 5-7.59 5.7-4.58 1-9.06-3.66-13.61-2.5-3.43.87-5.21 4.61-8.08 6.67S-5.12 61.17.9 68.81a6 6 0 0 0 3 1.75c14.77 4.73 32.29.12 47.41-.89 8.24-.55 17.58-1 26.25-1 5.92.1 19.2 3.73 27.39 1.24Zm123.77 27.14a7.47 7.47 0 0 1-5.38-4.91c-1.41-4.39 2.83-8.8 7.29-10s9.19-.31 13.78-.81 9-2.36 13.54-3.35 9.7-1 13.38 1.88c2.14 1.65 3.76 4.22 6.4 4.8 3.86.85 7.64-3.08 11.48-2.11 2.89.73 4.39 3.89 6.81 5.63s25.58 1.52 20.51 8a5.1 5.1 0 0 1-2.56 1.48c-12.46 4-27.24.1-40-.75-6.95-.46-14.83-.88-22.15-.85-4.99-.01-16.19 3.08-23.1.99Z"
    style="fill:#ddf1f1" />
  <path d="M214.56 149.97c5.64-.59 8.53 3.48 13.29 5.27-1.35 3.54-5.38 3.9-8.65 2.55-3.83-1.59-9.44-7.31-4.64-7.82Z"
    class="cls-3" />
  <path
    d="M356.31 88.05c6.89.28 13 4.08 19.87 4.67 3.11.27 10.13.06 10-4.47a1.94 1.94 0 0 0-1.87-2c-2.21 2.89-6.25 3.77-9.86 3.37s-7-1.84-10.53-2.76a36.83 36.83 0 0 0-16.62-.44 18.81 18.81 0 0 0-7.46 3 10.6 10.6 0 0 0-3.13 3.71c-4.44 5.13-8.51 13.73-11.23 20.86-3.35 8.78-14.55 18-24.67 20s-17.82 6.36-22.84 8.87l.07.18a19.45 19.45 0 0 0-6.6 5.2c-1.73 2.22-2.82 4.87-4.16 7.34-2 3.66-4.29 6.22-8.6 7a6.28 6.28 0 0 1-6.1-2c-4.27-5.78 6-11.45 9.35-14.37a22.19 22.19 0 0 0 3.92-4.5c.6-.91 1.12-2.16.45-3-.79-1-2.55-.45-3.24.64s-.74 2.46-1.14 3.69c-1.84 5.61-10 6.57-12.79 11.75-2 3.74-.32 8.86 3.3 11.09s8.56 1.72 12-.76c5.22-3.75 6.8-10.66 10.07-16.19a7.86 7.86 0 0 1 1.65-2.1 8.34 8.34 0 0 1 3.08-1.41c.36.58.81 1.25 1.38 2 13 17.4 29.38 16.16 33.36 15.56l.14.07a2.69 2.69 0 0 1 .27-.46c.35-.42.66-.85 1-1.27 4.58-14.19-.59-32.83-.59-32.83a33.81 33.81 0 0 0 5.47-4.78c13.82 6.55 31.25 6.13 32.59 5.49 5.55-22.74-4.81-33.43-10.12-37.27a8.46 8.46 0 0 1 .6-.8c2.72-3.08 9.18-3.25 12.98-3.08Z"
    class="cls-4" />
  <path
    d="M282.57 143.46c2.62 5.82 8.2 9.67 13.51 13.21a26.5 26.5 0 0 0 7.35 3.86 9 9 0 0 0 7.94-1.17c2.71-2.17 3.29-6 3.44-9.48a76.42 76.42 0 0 0-.46-12.07 6.32 6.32 0 0 0-.88-2.95c-1-1.48-3.14-1.84-4.91-1.44a23.3 23.3 0 0 0-4.94 2.22c-6.35 3.14-14.07 3.25-19.82 7.38"
    class="cls-1" />
  <g style="clip-path:url(#clip-path)">
    <path d="M269.201 188.08 278.84 63.1l116.713 9.001-9.638 124.979z" class="cls-4" />
    <path
      d="m367.38 155.94.82-10.52 1.39.12-.92 11.9-1.29-1.5zm2.57 3 1.03-13.28 1.39.12-1.13 14.66-1.29-1.5zm10.28 12 1.88-24.31 1.39.12-1.98 25.69-1.29-1.5zm2.57 3 2.09-27.07 1.39.12-2.19 28.45-1.29-1.5zm2.57 3 2.3-29.83 1.39.12-2.4 31.21-1.29-1.5zm-32.03-28.81-3.64-4.24 3.94.3 1.82 2.13-2.12 1.81zm-7.58-4.54 5.45 6.36-2.11 1.82-7.27-8.49 3.93.31zm-.91 11.81-10.9-12.72 3.94.3 9.08 10.6-2.12 1.82zm-4.23 3.63-14.54-16.96 3.93.3 12.72 14.85-2.11 1.81zm-4.25 3.64-18.17-21.21 3.94.3 16.35 19.09-2.12 1.82zm-22.11-21.51 19.99 23.33-2.12 1.81-21.8-25.45 3.93.31zm13.63 28.78-25.44-29.69 3.93.3 23.63 27.57-2.12 1.82zm-2.12 1.81-2.12 1.82-29.07-33.93 3.93.3 27.26 31.81zm-6.36 5.45-32.71-38.17 3.93.31 30.9 36.05-2.12 1.81zm-4.24 3.64-36.35-42.41 3.94.3 34.53 40.29-2.12 1.82z"
      class="cls-6" />
    <path
      d="m373.77 145.91-1.24 16-.4-.47-36 30.85 15.74 1.21 27.5-23.55-.44-.51 1.77-22.92-1.39-.12-1.66 21.54-1.29-1.5 1.55-20.16-1.39-.12-1.45 18.79-1.28-1.5 1.37-17.4Zm-99.8-7.86-3.79 49.18 1.32.1 3.46-44.85 1.29 1.5-3.35 43.45 1.39.11 3.24-42.06 1.29 1.5-3.14 40.67 1.39.11 3-39.28 1.29 1.5-2.92 37.88 1.39.11 2.81-36.49 1.29 1.5-2.69 35.07 1.39.11 2.6-33.71 1.29 1.5-2.49 32.31 1.39.11 2.38-30.92 1.29 1.5-2.28 29.53 1.39.11 2.17-28.1 1.28 1.5-2.06 26.75 1.39.11 2-25.36 1.29 1.5-1.85 24 1.39.11 1.74-22.57 1.29 1.5-1.63 21.18 1.39.11 1.53-19.79 1.29 1.5-1.42 18.39 1.39.11 1.31-17 1.29 1.5-1.2 15.61 1.39.11 1.1-14.22 1.29 1.5-1 12.82 1.39.11.88-11.43 1.29 1.5-.77 10 1.39.11.67-8.65 1.29 1.5-.56 7.25 11.28.87 44.49-38.12 1.25 1.46.7-9.14-1.39-.12-.6 7.76-1.29-1.5.49-6.38-1.39-.12-.39 5-1.29-1.5.28-3.62-1.39-.12-.17 2.24-1.29-1.5.07-.86-.87-.08-46.66 40 2.12-1.82-38.16-44.54Zm62.398-23.19.43-5.564 56.462 4.355-.43 5.563zm54.282 32.51-3.5 45.34-3.78 3.25-15.74-1.22 19.03-16.31 1.28 1.5 2.51-32.58.2.02zm-78.76-6.46v.01l-22.29-1.72-14.43-16.84 1.72-22.29 35 40.84z"
      class="cls-6" />
    <path
      d="m286.6 62.77 49.33 57.58v.08l56.46 4.35-.43 5.56-56.46-4.35-.43 5.58 56.46 4.35-.43 5.56-56.46-4.35-.43 5.51-55.6-64.9 1.2-15.49 6.79.52zm67 5.17-1.88 1.61 1.54 1.8-13.47-1.04.26-3.42 13.55 1.05z"
      class="cls-6" />
    <path
      d="m331.12 66.2 8.25 9.63-.44 5.61-.43 5.58 30.18 2.32-.61-.71 12.73-10.9-.3 3.94-10.61 9.08 1.82 2.13 8.48-7.27-.3 3.93-6.36 5.45.29.35-35.75-2.76-.42 5.54-28.82-33.64 22.29 1.72zm48.16 31.22-2.12 1.82-1.82-2.12 4.24-3.64-.3 3.94z"
      class="cls-6" />
    <path
      d="M381.17 70.05 364.45 84.4l1.82 2.12 14.85-12.72.27-3.45-2.39 31-41.34-3.19-.43 5.56 56.45 4.33.43-5.56-6.43-.5 2.41-31.26Zm-15.75-1.2-8.24 7.06 1.19 1.44-19-1.47-.43 5.56 24.61 1.9-.92-1.07 14.6-12.51-3.94-.3-12.48 10.7-1.82-2.11 10.38-8.9Z"
      class="cls-6" />
    <path d="m361.48 68.54-6.13 5.25-1.81-2.12 4-3.43 3.94.3z" class="cls-6" />
  </g>
  <path
    d="M163.37 402.3c-.79 3.75-7.93 6.36-6 9.86.86 1.56 3.22 2.22 5.35 2.6 9.11 1.61 18.58 1.17 27.9.72l74.78-3.61c-1.69-1.86-.91-4.78 1.59-6 1.7-.81 4.23-1.12 4.67-2.63.57-2-3-2.91-5.63-2.94q-43.73-.45-87.45 1.06c-6.42.22-13.5.7-17.94 4.32m-5.72-322.04c-7 2.24-14.75 2.89-21.31-.39s-11.3-11.33-9.39-18.76c1.44-5.56 10.34-12.34 7.26-18.77-2.78-5.8-13-3.41-18.12-3.5a20.89 20.89 0 0 1-7.14-.92 7.66 7.66 0 0 1-4.93-5.16c-.69-3 1-6.09 3.31-7.9 4.16-3.22 10-3.62 14.9-4.76 6.41-1.49 12.77-3.23 19.08-5.15 7.61-2.31 15.36-4 22.53-7.72a14.72 14.72 0 0 0 5-3.8 6.71 6.71 0 0 0 1.28-6.15c.16-.8 1.35-.87 1.86-.26a3.17 3.17 0 0 1 .42 2.34c-1.51 14.77-17 16.39-28.52 19.28-1.94.49-4.06 1.09-5.19 2.75a4.57 4.57 0 0 0 .7 5.68c4.41 4.18 16.43.59 21.11-1.31 3.66-1.48 6.82-4.39 10.69-5.32 5.1-1.23 6.67 2.63 10.73 4.66 3 1.51 6.84 1.32 10.08 1.14 4.56-.25 9.62-.44 13.09 2.68s2.82 10.78-1.73 11.23"
    class="cls-7" />
  <path
    d="M150.37 69.17c-6.61-.25-7.94 8.76-12 12.2-3.29 2.8-8 2.89-12.36 2.6-2.73-.18-17.52-1-16.34 4.58a4.07 4.07 0 0 0 2.49 2.52 14.31 14.31 0 0 0 6.84 1.35c.6 0 1.35-.23 1.45-.83.21-1.33-2.86-1.16-2.69-2.5.46-1.61 2.72-1.62 4.35-1.25 6.45 1.47 12.57 4.16 19.24 4.46 6.47.29 12.91-1.15 19.24-2.26 6.67-1.16 13.44-2 19.88-4.1s12.64-5.62 16.61-11.1c2.53-3.49 4-8.28 2-12.1s-6.61-5.28-10.84-6c-7.49-1.23-20.67-2.55-27.45 1.74-2.16 1.37-3.11 4-4.14 6.31a10.13 10.13 0 0 1-7 6.09"
    class="cls-7" />
  <path
    d="M192.53 67.52c.31.43-.56.88-.92.5a1.62 1.62 0 0 1-.13-1.51c.89-3.46 1.81-10.39 4.89-12.46 2.08-1.36 4.66-1.61 7.14-1.79 5.29-.38 11-3 12.3-8.73 1-4.51-.44-13.15 4.24-16 .15-.09 2-1.2 2.93-.46s1.88 1.71 1.88 1.71-1.2-4.65-6.5-3c-8.53 2.73-4.94 13.8-14.46 15.78-5 1-9.45-1.35-14.35-1.2-4.06.12-6.19 1.42-10.58.68-8.88-1.5-9.95-9.24-17.77-11.87a8.75 8.75 0 0 0-1 4.11"
    class="cls-7" />
  <path
    d="M191.96 60.98c1.91-2 4-.34 6.17.32 1.91.57 4.59 1.28 6.25-.26 1-.93 1.37-2.39 2.2-3.46a13 13 0 0 1 2.47-2.43c-.15.11-1 .07-1.31.16a6.29 6.29 0 0 0-1.61.87c-1.49 1-2.84 2.5-4.8 2.11s-3.36-2.27-5.35-2.71c-3.6-.78-6.57 3-6.57 3l.06 2Z"
    class="cls-7" />
  <path
    d="m175.32 85.36-.18.85c-1.42 6.88-1.71 10.49-9.7 8.77l-5-1.07a8.4 8.4 0 0 1-3.73-1.46c-3.87-3.24-1.18-6.31-1.06-10.13.11-3.35-1.89-6.73-3.55-9.24a31.41 31.41 0 0 1-5.04-14.03c-1.74-16.67 20.72-24.45 30.76-11.9 3.16 4 4.53 9 5.83 13.88l1.36 5.12a8.62 8.62 0 0 1 .34 4.7c-.65 2.09-2.71 3.33-4.49 4.59-2.88 2-4.79 6.54-5.54 9.92Z"
    class="cls-8" />
  <path
    d="m149.22 165.5-10.52 37.46a141.16 141.16 0 0 0-4.47 19.39c-1.72 12.9.15 26 2.43 38.8a618.08 618.08 0 0 0 26.39 99.52c2.27 6.37 4.67 12.79 5.35 19.52s-.56 13.94-4.88 19.15-10.85 9.43-16.31 13.52c-1 .78-2.17 1.72-2.24 3-.14 2.43 3.18 3.25 5.62 3.22 10.35-.13 27.66 2.73 33.78-8.67 2.13-4 5.67-11.86 6.54-16.28 1.09-5.58-2.34-10.88-4.69-16.05-10.31-22.68-.69-50.71-11.17-73.31a46.89 46.89 0 0 1-3.15-7.3 50.3 50.3 0 0 1-1-7c-.77-6.29-3.05-12.31-4-18.58a43.83 43.83 0 0 1 4.5-26.46"
    class="cls-9" />
  <path
    d="M205.14 108.28c6 10.74 4.55 24 1.65 36s-7.12 23.94-6.16 36.2c1.46 18.67 13.67 36.43 9.89 55.28a42.93 42.93 0 0 1-17.37 26.48c-6.76 4.7-14.09 6.57-19.76 12.91-3.54 4-4 4.55 1.91 6s11.39 2.66 16.72 5.86a16.76 16.76 0 0 1 4 3.07c1 1.11 1.74 2.43 2.84 3.43 5.52 5.07 15.73 1.67 22.34 4.34 8.07 3.26 6.63 12.52 7.76 19.55.76 4.75 2.93 9.15 4.5 13.7s2.53 9.62.85 14.13-6.83 8-11.36 6.37c-4.16-1.48-6.08-6.35-6.39-10.76s.48-8.92-.55-13.22c-1.61-6.73-7.47-11.74-13.86-14.4s-13.37-3.41-20.18-4.6a152.87 152.87 0 0 1-37.71-11.75c-7.08-3.26-14.57-7.87-16.53-15.42-2.6-10 5.59-19.25 13.09-26.33s15.43-14.53 24.85-19.2c.09-2.23 3.36-1.67 5.13-3 2.85-2.14 2.53-6.45 1.79-9.94a147.65 147.65 0 0 0-6.22-21.29c-1.74-4.68-3.72-9.26-5.6-13.89a340.69 340.69 0 0 1-17.81-58.44c-1.41-6.73-2.61-13.58-2.16-20.44s2.71-13.8 7.44-18.78c5-5.24 12.34-7.86 19.56-7.86s14.3 2.45 20.53 6.12c7.45 4.39 14.09 11 16.35 19.31"
    class="cls-8" />
  <path
    d="M146.5 98.44c-6.34 4.95-3.91-3.87-8.81 2.93s-4.59 7.94-1.62 16.14 7.63 15.58 9.6 24.17c1.59 6.91 1.35 14.21 2.33 21.27a120 120 0 0 0 4.18 17.34l10.52 35.69c1.25 4.25-.29 14.79 4 16.55 18.5 7.63 14.63-19 8.49-27.78-2.59-3.69-6.09-6.86-7.67-11.08-5.69-15.18-5.2-30.83-7.59-46.71a60.59 60.59 0 0 0-15.17-32.07m42.15 23.01-3.76-8c-.32-.68-.47-1.75.26-1.93a78.15 78.15 0 0 1 8.96 11.34 8.82 8.82 0 0 1-5.55.85l-.45-2.33"
    class="cls-9" />
  <path
    d="M156.23 84.68c-7.38 5-20.47 5.8-26.18 12.64s-4.6 17.21-1.15 25.46 8.89 15.69 11.19 24.33c1.85 7 1.57 14.3 2.71 21.41a107.31 107.31 0 0 0 4.88 17.45l12.26 35.92c1.46 4.27 1.77 8.86 6.74 10.63a9.11 9.11 0 0 0 9.7-2.55c2.35-2.71 2.83-6.54 3-10.13a17.76 17.76 0 0 0-.8-7c-2-5.27-7.92-7.91-11.16-12.53-2.44-3.49-3.19-7.84-3.88-12-1.58-9.67-2.22-19.13-4-28.79-1.79-9.92-5.67-21.34-5.67-31.39-1.15-6.34-2.22-13.2.68-19"
    class="cls-8" />
  <path
    d="M181.18 90.05c5.06-3.31 7.64-5.54 13.8-5.35 5.11.16 9.82 2.9 13.27 6.45s5.83 7.89 8.17 12.17l10.55 19.33c2.62 4.8 5.29 9.76 5.76 15.14 1 11.11-7.78 17.12-18.65 16.41-11.4-.75-22.69-3.89-34.18-3.17-10.08.64-20.41 8.36-30.36 2.92-2-1.07-3.55-3-3.51-5.12.12-6.58 14.64-12.91 20.42-12.34a42.41 42.41 0 0 1 7.57 2c7.19 2.09 33.71 5.47 36.28-4.13 1.95-7.27-10.33-19.9-14.14-25.74"
    class="cls-9" />
  <path
    d="M172.93 82.68c5.06-3.52 14.08-6.18 20.24-6 5.11.17 9.82 3.08 13.27 6.85s5.83 8.38 8.17 12.93l10.56 20.59c2.62 5.1 5.29 10.36 5.76 16.08 1 11.8-7.78 18.19-18.65 17.43-11.4-.79-22.69-4.14-34.18-3.36-10.08.68-20.41 8.88-30.36 3.1a6.54 6.54 0 0 1-3.51-5.44c.12-7 14.64-13.71 20.42-13.1 2.61.27 5.07 1.31 7.57 2.08 7.19 2.22 33.71 5.81 36.28-4.39 1.95-7.72-10.33-21.14-14.14-27.34"
    class="cls-8" />
  <path
    d="M154.55 38.45c3.41 0 6.1 3.47 6.16 6.88.13 8.11-8.55 6.66-11.7 12.68-2.25 4.32.42 10.4 5.12 11.67a15.15 15.15 0 0 0 5.86.07 11.25 11.25 0 0 0 4.25-1.17 15.92 15.92 0 0 0 3.7-3.68c1.15-1.32 2.58-2.58 4.33-2.72s3.66 1.4 3.27 3.11c-2.19-1.21-4.88.76-6 3s-1.48 4.89-3.11 6.8a10.48 10.48 0 0 1-5.15 2.91c-6 1.76-13.18 1.69-18.27-2.41-5.51-4.43-5.54-13.24-2-19.36s9.69-10.19 15.62-14"
    class="cls-7" />
  <path d="M165.31 208.81c9.08-2.52 14.94 3.37 23.24 5-1.24 6.17-7.74 7.87-13.49 6.56-6.76-1.56-17.48-9.41-9.75-11.56Z"
    class="cls-3" />
  <path
    d="M177.95 217.38c-5.5-.32-9.94-3.38-14.9-5.4a3.07 3.07 0 0 1-.36-.19c.72 3.16 7.55 7.47 12.38 8.57 5.08 1.16 10.74 0 12.85-4.6a24 24 0 0 1-9.97 1.62Z"
    class="cls-10" />
  <path
    d="M232.9 235.73c6-1.1 9.44 3 14.7 4.56-1.16 3.91-5.45 4.63-9.08 3.45-4.28-1.39-10.74-7.08-5.62-8.01Zm-129.65-18.38c6-1.1 9.44 3 14.7 4.56-1.16 3.91-5.45 4.63-9.08 3.45-4.27-1.38-10.73-7.07-5.62-8.01Zm-19.7-63.03c4.45-5.94 10.93-5.09 16.88-8.07 2.2 4.44-1 8.63-5.25 10.58-4.96 2.29-15.42 2.56-11.63-2.51Z"
    class="cls-3" />
  <path d="M100.05 146.5c-5.63 2.39-11.59 2-15.77 7.56a5.45 5.45 0 0 0-.45.71c6.69-1.22 12.07-3.11 16.22-8.27Z"
    class="cls-10" />
  <path d="M270.09 196.15c-5.41 1.12-8.61-2.55-13.4-3.81 1-3.56 4.83-4.3 8.14-3.32 3.9 1.16 9.87 6.17 5.26 7.13Z"
    class="cls-3" />
  <path d="M257.02 192.39c4.32 1.44 7.45 4.61 12.53 3.55a4.06 4.06 0 0 0 .6-.17c-4.33-2.62-8.26-4.22-13.13-3.38Z"
    class="cls-10" />
</svg>`, k = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40"><defs><path id="a" d="M0 18.208 8.208 10 0 1.792 1.792 0 10 8.208 18.208 0 20 1.792 11.792 10 20 18.208 18.208 20 10 11.792 1.792 20z"/></defs><g fill="none" fill-rule="evenodd"><rect width="40" height="40" fill="#000" fill-opacity=".4" rx="20"/><use xlink:href="#a" fill="#FFF" transform="translate(10 10)"/></g></svg>', p = (
  /** @type {const} */
  {
    close: "AccountDropdown_ClosePopup",
    dashboardClick: "AccountDropdown_DashboardButtonClick",
    logout: "AccountDropdown_LogoutClick",
    open: "AccountDropdown_OpenPopup",
    recentSearchClick: "AccountDropdown_PastSearchClick",
    upcomingVoyageClick: "AccountDropdown_UpcomingVoyageClick"
  }
), A = "Open account dropdown, dialog pop-up, expanded. ", T = "/book";
function h(e, ...o) {
  return String.raw(
    { raw: e },
    ...o.map((t) => t || "")
  );
}
function f(e) {
  return document.createRange().createContextualFragment(e);
}
function b(e, o) {
  document.cookie.split("; ").some((n) => n.trim().startsWith(`${e}=`)) && (document.cookie = `${e}=;path=${o};expires=Thu, 01 Jan 1970 13:13:13 GMT;max-age=0`);
}
const w = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
function D(e, o, t = !1) {
  var l, d;
  const n = t ? /* @__PURE__ */ new Date(`${(l = e == null ? void 0 : e.split("T")) == null ? void 0 : l[0]}T00:00`) : /* @__PURE__ */ new Date(`${e}T00:00`), s = t ? /* @__PURE__ */ new Date(`${(d = o == null ? void 0 : o.split("T")) == null ? void 0 : d[0]}T00:00`) : /* @__PURE__ */ new Date(`${o}T00:00`);
  if (isNaN(n.getTime()) || isNaN(s.getTime())) return "—";
  const a = w[n.getMonth()] ?? "", i = w[s.getMonth()] ?? "";
  let c = `${a} ${n.getFullYear()}`, r = `${i} ${s.getFullYear()}`;
  return t && (c = `${a.slice(0, 3)} ${n.getDate()}, ${n.getFullYear()}`, r = `${i.slice(0, 3)} ${s.getDate()}, ${s.getFullYear()}`), `${c} - ${r}`;
}
function $(e) {
  const {
    backgroundImageUrl: o,
    debarkDate: t,
    embarkDate: n,
    packageName: s,
    reservationNumber: a,
    sailorCount: i = 0
  } = e || {}, c = "1 cabin", r = `${i} ${i === 1 ? "person" : "persons"}`, l = D(n, t, !0), d = `Upcoming voyage ${a} ${s} ${c} ${r} ${l}`;
  return h`
    <div
      aria-label="${d}"
      class="AD_SearchResults_ListItem AD_VoyagesList"
      data-reservationnumber="${a}"
      tabindex="0"
      role="button"
    >
      <div class="AD_SearchResults_ListItem_Img_Wrap">
        <img
          class="AD_SearchResults_ListItem_Img"
          src="${o.src}"
          alt="${o.alt}"
        />
      </div>
      <div class="AD_SearchResults_ListItem_Details">
        <span class="AD_SearchResults_ListItem_Title">${s}</span>
        <span class="AD_SearchResults_ListItem_Cabins"> ${c} ${r} </span>
        <span class="AD_SearchResults_ListItem_Dates"> ${l} </span>
      </div>
    </div>
  `;
}
function I(e, o) {
  const { filtersSearchParams: t, title: n, uuid: s } = e, { cabins: a = 1, dateFrom: i, dateTo: c, sailors: r = 2 } = t, l = `${a} ${+a == 1 ? "cabin" : "cabins"}`, d = `${r} ${+r == 1 ? "person" : "persons"}`, g = `${l} · ${d}`, _ = i && c ? D(i, c) : "", y = `${o}, Option: ${n}, ${g}, ${_}, Search again`;
  return h`
    <a
      aria-label="${y}"
      class="AD_SearchResults_ListItem"
      href="${T}/voyage-planner/find-a-voyage?${new URLSearchParams(t)}"
      tabindex="0"
      data-recentsearchid="${s}"
    >
      <span class="AD_SearchResults_ListItem_Title">${n}</span>
      <span class="AD_SearchResults_ListItem_Cabins">${g}</span>
      <span class="AD_SearchResults_ListItem_Dates">${_}</span>
    </a>
  `;
}
function M(e) {
  if (e) {
    const o = window.location.pathname.includes("/accounts/v1/account/");
    return h`<a
      href="${this.getBasePathUrl()}/accounts/v1/account/dashboard"
      class="AD_DashboardButton"
      tabindex="0"
      id="js-dashboardButton"
      aria-label="Go to your account"
    >
      ${o ? "My account" : "Go to your account"}
    </a>`;
  }
  return h`<a
    href="${this.getBasePathUrl()}/auth/v1/signin"
    class="AD_DashboardButton"
    tabindex="0"
    id="js-dashboardButton"
    aria-label="Sign in to your account"
    >Sign in to your account</a
  >`;
}
function R(e, o, t, n = !1) {
  var g;
  let s, a = "Nothing to see here!";
  o.length > 0 && !n && (a = "Recent searches", s = o.slice(0, 2).map((_) => I(_, a)).join("")), e && t.length > 0 && (a = "Upcoming voyages", s = t.slice(0, 2).map($).join(""));
  const i = !s, c = h`${O(C, "AD_SearchResults_Img")}`, r = h`<span class="AD_SearchResults_List_NoSearches" role="paragraph">
    You have no recent searches
  </span>`, l = window.matchMedia("(max-device-width: 576px)").matches, d = (g = window == null ? void 0 : window.location) == null ? void 0 : g.pathname.includes("/accounts/v1");
  return h`
    <div class="AD_Content leftSided ${l && "AD_Content_Mobile"} ${t.length > 0 && "hasVoyages"} ${d && "AD_Content_InAccountApp"}" id="js-content">
      <button aria-label="Close" class="AD_MobileCloseIcon" id="js-mobileCloseButton" tabindex="0">
        ${k}
      </button>

      <div class="AD_SearchResults">
        ${i && c}

        <h3 class="AD_SearchResults_Title">${a}</h3>

        ${i && r}

        <div class="AD_SearchResults_List">${s}</div>
      </div>

       ${!n && M.call(this, e)}

      <!---->
      ${e && h` <button class="AD_LogoutButton" tabindex="0" id="js-logoutButton">Logout</button>`}
    </div>
  `;
}
function z(e, o) {
  return h` 
  <button
    class="AD_TriggerIcon ${e && "AD_ShowMobileLabel"}"
    aria-expanded="false"
    aria-label="Open account dropdown"
    id="js-trigger"
    tabindex="0"
  >
    <span class="AD_MyAccountLabel">${o && "My account"}</span>
    <svg class="AD_TriggerIcon_Account ${o && "AD_TriggerIcon_Account_Voyages_Edit"}" viewBox="0 0 24 24">
      <path class="AD_TriggerIcon_Account_Status" d="M11.3 20H3.2v-5.7h8.2V20z" />
      <path
        d="M18.23 10.42a4.19 4.19 0 1 0-4.76 0A6.16 6.16 0 0 0 10.56 13a2.61 2.61 0 0 0-.48 0h-.34a2.45 2.45 0 0 0-4.87 0h-.43A2.44 2.44 0 0 0 2 15.42v3.39a2.44 2.44 0 0 0 2.44 2.44h5.63a2.45 2.45 0 0 0 2.44-2.44v-3.38a2.37 2.37 0 0 0-.4-1.37 4.27 4.27 0 0 1 8 2H22a6.2 6.2 0 0 0-3.77-5.64zM7.31 12.29a1 1 0 0 1 .91.69H6.39a1 1 0 0 1 .92-.69zm3.44 6.52a.69.69 0 0 1-.68.68H4.44a.68.68 0 0 1-.68-.68v-3.39a.68.68 0 0 1 .68-.68h5.63a.69.69 0 0 1 .68.68zm5.1-9.53A2.33 2.33 0 1 1 18.17 7a2.32 2.32 0 0 1-2.32 2.28z"
      />
    </svg>
    <svg class="AD_TriggerIcon_Arrow ${o && "AD_TriggerIcon_Arrow_Voyages_Edit"}" viewBox="0 0 24 24">
      <path
        d="M12 15a1.05 1.05 0 0 0 .75-.31l4.25-4.2L15.5 9 12 12.46 8.5 9 7 10.49l4.25 4.2A1.05 1.05 0 0 0 12 15z"
      />
    </svg>
    <span class="AD_TriggerIcon_MobileLabel ${o && "AD_TriggerIcon_MobileLabel_Voyages_Edit"}">ACCOUNT</span>
  </button>`;
}
function P(e, o, t, n) {
  return h`
    <div class="AD_Main ${o && "hasSearchResults"}" id="js-main">
      ${z(t, n)}
      <!---->
      ${e}
      <div class="AD_ContentOverlay"></div>
    </div>
  `;
}
class m extends HTMLElement {
  constructor() {
    super();
    /**
     * @type {HTMLElement[]}
     */
    u(this, "_focusable", []);
    // TODO: remove when account pod wouldn't use it
    u(this, "rerenderADContent", () => {
    });
    u(this, "shadowRoot", this.attachShadow({ mode: "open" }));
    u(this, "tree", new Proxy(
      /** @type {Record<'trigger'|'content'|'main'|'mobileCloseButton'|'dashboardButton'|'logoutButton', HTMLElement>} */
      {},
      {
        get: (t, n) => {
          var s;
          return (s = this.shadowRoot) == null ? void 0 : s.getElementById(`js-${String(n)}`);
        }
      }
    ));
    Object.getOwnPropertyNames(Object.getPrototypeOf(this)).filter((n) => n.startsWith("on")).forEach((n) => {
      this[n] = this[n].bind(this);
    });
    const t = document.createElement("style");
    t.textContent = S, this.shadowRoot.appendChild(t);
  }
  _updateAriaLabel() {
    var a;
    let t = "Open account dropdown", n = !1;
    const s = this.getAttribute("authorized");
    try {
      n = JSON.parse(this.getAttribute("recent-searches") || "[]").length;
    } catch {
    }
    n && (t += ", view recent searches"), s ? t += ", go to your account or log out" : t += ", sign in to your account or sign up", t += ", dialog pop up", (a = this.tree.trigger) == null || a.setAttribute("aria-label", t);
  }
  _closePopup() {
    var t, n, s;
    (t = this.tree.main) == null || t.classList.remove("isOpen"), (n = this.tree.trigger) == null || n.setAttribute("aria-expanded", "false"), this._hidePopupExpandedStatus(), document.body.classList.remove("-accountDropdownOpen", "no-scroll"), document.removeEventListener("click", this.onPopupOutsideClick), document.removeEventListener("keydown", this.onDocumentKeydown), this._updateAriaLabel(), (s = this.tree.trigger) == null || s.focus(), this._track(p.close);
  }
  _showPopupExpandedStatus() {
    var n, s, a;
    const t = ((n = this._focusable[1]) == null ? void 0 : n.ariaLabel) ?? ((s = this._focusable[1]) == null ? void 0 : s.innerText) ?? "";
    (a = this._focusable[1]) == null || a.setAttribute("aria-label", A + t);
  }
  _hidePopupExpandedStatus() {
    var n, s, a, i;
    (s = (n = this._focusable[1]) == null ? void 0 : n.querySelector("#popup-expanded-status")) == null || s.remove();
    const t = (a = this._focusable[1]) == null ? void 0 : a.ariaLabel;
    if (t) {
      const c = t == null ? void 0 : t.replace(A, "");
      (i = this._focusable[1]) == null || i.setAttribute("aria-label", c);
    }
  }
  _hydrate() {
    var t;
    (t = this.tree.trigger) == null || t.addEventListener("click", this.onTriggerClick);
  }
  _hydrateContent() {
    this.tree.dashboardButton && this.tree.dashboardButton.addEventListener("click", this.onDashboardButtonClick), this.shadowRoot.querySelectorAll(".AD_SearchResults_ListItem:not(.AD_VoyagesList)").forEach((t) => {
      t == null || t.addEventListener("click", this.onPastSearchClick);
    }), this.shadowRoot.querySelectorAll(".AD_SearchResults_ListItem.AD_VoyagesList").forEach((t) => {
      t == null || t.addEventListener("click", this.onUpcomingVoyageClick);
    }), this.getAttribute("authorized") && this.tree.logoutButton.addEventListener("click", this.onLogoutClick), this.tree.mobileCloseButton.addEventListener("click", () => this._closePopup());
  }
  _openPopup() {
    var a, i, c, r, l, d;
    this._syncAttributesWithLocalStorage(), this._updateContent();
    const t = window.innerWidth >= 768;
    t ? ((a = this.tree.content) == null || a.classList.remove("leftSided"), this._setPopupContentPosition()) : (document.body.classList.add("-accountDropdownOpen", "no-scroll"), (i = this.tree.content) == null || i.classList.add("leftSided"), (c = this.tree.content) == null || c.classList.remove("centered")), (r = this.tree.main) == null || r.classList.add("isOpen"), (l = this.tree.trigger) == null || l.setAttribute("aria-expanded", "true"), this._updateAriaLabel();
    const n = this.shadowRoot.querySelector(".AD_DashboardButton");
    (window.location.pathname.includes("My-Voyage") || window.location.pathname.includes("my-voyages")) && n && (n.innerHTML = "My Account"), document.addEventListener("click", this.onPopupOutsideClick), document.addEventListener("keydown", this.onDocumentKeydown), this._updateFocusable();
    const s = t ? 1 : 0;
    this._showPopupExpandedStatus(), (d = this._focusable[s]) == null || d.focus(), this._track(p.open);
  }
  /**
   * Set dropdown content X position depending on position of trigger icon
   */
  _setPopupContentPosition() {
    var n;
    const t = (n = this.tree.main) == null ? void 0 : n.getBoundingClientRect().left;
    this.tree.content && (t < 180 ? (this.tree.content.classList.remove("leftSided"), this.tree.content.classList.remove("centered")) : window.innerWidth - t < 180 ? (this.tree.content.classList.remove("centered"), this.tree.content.classList.add("leftSided")) : (this.tree.content.classList.remove("leftSided"), this.tree.content.classList.add("centered")));
  }
  _syncAttributesWithLocalStorage() {
    localStorage.getItem("Authorization") ? this.setAttribute("authorized", "true") : this.removeAttribute("authorized"), this.setAttribute("recent-searches", localStorage.getItem("recentSearches") || "");
  }
  /**
   * @param {typeof EVENTS[keyof typeof EVENTS]} event
   * @param {Object} payload
   */
  _track(t, n = {}) {
    this.dispatchEvent(new CustomEvent(t, { bubbles: !0, detail: n }));
  }
  _updateContent() {
    var i;
    const t = !!this.getAttribute("authorized"), n = JSON.parse(this.getAttribute("recent-searches") || "[]"), s = JSON.parse(this.getAttribute("voyages") || "[]"), a = this.getAttribute("isCharter") === "true";
    (i = this.tree.content) == null || i.remove(), this.tree.main != null && (this.tree.main.appendChild(
      f(R.call(this, t, n, s, a))
    ), n.length > 0 && !a ? this.tree.main.classList.add("hasSearchResults") : this.tree.main.classList.remove("hasSearchResults"), this._hydrateContent(), this._updateFocusable());
  }
  _updateFocusable() {
    var t;
    this._focusable = /** @type {HTMLElement[]} */
    Array.from(((t = this.tree.main) == null ? void 0 : t.querySelectorAll('[tabindex="0"]')) || []).filter((n) => typeof n.checkVisibility == "function" ? n.checkVisibility() : n.clientHeight !== 0);
  }
  /**
   * @param {string} key
   * @param {string} prevValue
   * @param {string} newValue
   */
  attributeChangedCallback(t, n, s) {
    n !== s && (this._updateAriaLabel(), this._updateContent());
  }
  connectedCallback() {
    var i;
    if (this.shadowRoot.children.length !== 1) return;
    const t = JSON.parse(localStorage.getItem("recentSearches") || "[]"), n = this.getAttribute("showLabelOnMobile"), s = (i = window == null ? void 0 : window.location) == null ? void 0 : i.pathname.includes("accounts/v1/my-voyages");
    this.shadowRoot.appendChild(
      f(
        P(
          h` <div id="js-content"></div>`,
          t.length > 0,
          n != null,
          s
        )
      )
    );
    const a = document.createElement("style");
    if (a.innerHTML = `
    .AD_MyAccountLabel {
    font-size: 13px;
    font-weight: 700;
    color: #6e6e6e;
    line-height: 20px;
    letter-spacing: 3.3px;
    text-transform: uppercase;
    padding: 5px 5px 0;
    
    @media (max-width: 1200px) {
      font-size: 11px;
    }
    
    @media (max-width: 576px) {
      display: none;
    }
  }`, this.shadowRoot.appendChild(a), s) {
      const c = document.createElement("style");
      c.innerHTML = `
      @media (max-width: 767.98px) {
        .AD_TriggerIcon_MobileLabel:not(.AD_HideMobileLabel) {
          padding: 0;
          display: none;
        }
        .AD_TriggerIcon_Arrow:not(.AD_HideMobileLabel) {
          display: block;
        }
        .AD_TriggerIcon_Account {
          fill: #686d72;
        }
      }
    `, this.shadowRoot.appendChild(c);
    }
    this._syncAttributesWithLocalStorage(), this._hydrate(), this._updateAriaLabel();
  }
  onDashboardButtonClick() {
    this._track(p.dashboardClick);
  }
  /**
   * @param {KeyboardEvent} event
   */
  onDocumentKeydown(t) {
    var a;
    if (this._hidePopupExpandedStatus(), t.key === "Escape") {
      this._closePopup();
      return;
    }
    t.key === " " && (t.preventDefault(), (a = this.shadowRoot.activeElement) == null || a.click());
    const n = {
      ArrowDown: 1,
      ArrowLeft: -1,
      ArrowRight: 1,
      ArrowUp: -1,
      Tab: t.shiftKey ? -1 : 1
    }, s = this._focusable.indexOf(this.shadowRoot.activeElement);
    if (s !== -1 && t.key in n) {
      t.preventDefault();
      const i = n[t.key], c = this._focusable.at((s + i) % this._focusable.length);
      c == null || c.focus();
    }
  }
  getAfterLogoutUrl() {
    return this.getAttribute("afterLogoutUrl") || document.body.getAttribute("data-after-logout-url");
  }
  getBasePathUrl() {
    return this.getAttribute("basePath") || document.body.getAttribute("data-base-path") || "";
  }
  async onLogoutClick() {
    this._closePopup();
    const t = JSON.parse(localStorage.getItem("Authorization") || "{}"), n = this.getAttribute("authLogoutUrl"), s = this.getAttribute("isCharter") === "true";
    try {
      n && await fetch(n, {
        body: "{}",
        headers: {
          Authorization: `Bearer ${t == null ? void 0 : t.accessToken}`,
          "Content-Type": "application/json"
        },
        method: "POST"
      }), localStorage.removeItem("Authorization"), sessionStorage.setItem("isEligibleForFVC", "false"), sessionStorage.removeItem("primarySailor"), sessionStorage.removeItem("additionalSailors"), b("token", "/accounts/v1/"), b("token", "/auth/v1"), b("token", "/auth/"), b("token", "/"), this._track(p.logout), s ? this.remove() : window.location.href = this.getAfterLogoutUrl() ?? "/";
    } catch (a) {
      console.error(a);
    }
  }
  /**
   * Handler for recent searches items
   * TODO: rename (past -> recent) when we'll be sure that no one uses this api outside
   * @param {Event} event
   */
  onPastSearchClick(t) {
    var n;
    this._closePopup(), this._track(p.recentSearchClick, {
      // @ts-expect-error Non generic type
      pastSearchUUID: (n = t.currentTarget) == null ? void 0 : n.dataset.recentsearchid
    });
  }
  /**
   * @param {MouseEvent} event
   */
  onPopupOutsideClick(t) {
    var a;
    const n = t.composedPath().includes(this.tree.content), s = t.composedPath().includes(this.tree.trigger);
    (a = this.tree.main) != null && a.classList.contains("isOpen") && !n && !s && this._closePopup();
  }
  onTriggerClick() {
    var n;
    ((n = this.tree.main) == null ? void 0 : n.classList.contains("isOpen")) ? this._closePopup() : this._openPopup();
  }
  /**
   * @param {Event} event
   */
  onUpcomingVoyageClick(t) {
    var n;
    this._track(p.upcomingVoyageClick, {
      // @ts-expect-error Non generic type
      reservationNumber: (n = t.currentTarget) == null ? void 0 : n.dataset.reservationnumber
    });
  }
  /**
   * TODO: remove when account pod wouldn't use it
   * @param {string} value - json string with upcoming Voyages[]
   */
  set voyages(t) {
    this.setAttribute("voyages", t);
  }
}
u(m, "observedAttributes", ["voyages", "authorized", "recent-searches"]);
function O(e, o) {
  return e.replace(/<svg([\s\S]*?)>/, `<svg$1 class="${o}">`);
}
window.customElements.get("account-dropdown") ? console.warn(
  "AccountDropdown is already defined. If you are using it in a CMS, please remove the old version."
) : window.customElements.define("account-dropdown", m);
function x() {
  const e = document.getElementById("booking-account");
  if (e && (e == null ? void 0 : e.children.length) === 0) {
    const o = new m();
    return o.setAttribute("showLabelOnMobile", ""), e.appendChild(o), e.tabIndex = -1, e.removeAttribute("title"), e.removeAttribute("aria-expanded"), e.setAttribute("aria-label", "Account dropdown menu"), e.setAttribute("role", "document"), e.addEventListener("focus", () => {
      var t, n;
      return (n = (t = o == null ? void 0 : o.tree) == null ? void 0 : t.trigger) == null ? void 0 : n.focus();
    }), !0;
  }
}
function B(e) {
  x();
}
setInterval(x, 1e3);
export {
  m as AccountDropdown,
  x as render,
  B as renderWithConfig
};
